import { useTranslation } from "react-i18next";

import BaseButton from "@/components_v2/Button/BaseButton";
import { BUTTON_SIZES, BUTTON_TYPES } from "@/components_v2/Button/constants";
import { MODERATION_PATH } from "@/domains/moderation/constants";
import { useModerationQueue } from "@/domains/moderation/hooks/useModerationQueue";
import {
  formatWaitingAge,
  getWaitingTitleKey,
} from "@/domains/moderation/utils";

import "./styles.css";

const ModerationAlert = () => {
  const { t } = useTranslation();
  const { isAdmin, count, postCount, commentCount, oldestCreatedAt } =
    useModerationQueue();
  if (!isAdmin || count === 0) {
    return null;
  }

  return (
    <section className="moderation-alert flex flex-wrap items-center justify-between gap-300">
      <div className="flex flex-col gap-50">
        <h2 className="moderation-alert-title body-m-medium">
          {t(getWaitingTitleKey(postCount, commentCount), { count })}
        </h2>

        <p className="moderation-alert-line body-s-regular">
          {oldestCreatedAt
            ? t("moderation.alert.line", {
                age: formatWaitingAge(t, oldestCreatedAt),
              })
            : t("moderation.alert.lineNoAge")}
        </p>
      </div>

      <BaseButton
        type={BUTTON_TYPES.LINK}
        size={BUTTON_SIZES.SMALL}
        to={MODERATION_PATH}
      >
        {t("moderation.alert.open")}
      </BaseButton>
    </section>
  );
};

export default ModerationAlert;
